import React, { useState, useEffect } from 'react';
import { Page, SearchBar } from 'components';
import { Results } from './components';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import { Button, Row, Col } from 'react-bootstrap';
import ApiMServer from 'services/ApiMServer';
import { loadState, saveState } from 'utils/persistState';
import { matchesUserSearch } from 'utils/searchMatch';
import { useAppTheme } from '../../contexts/ThemeContext';

const User = () => {
  const user = JSON.parse(localStorage.getItem('userData'));
  if (user && user?.permission?.users?.read !== true) {
    window.location.replace('/home');
  }

  const [allUsers, setAllUsers] = useState([]);
  const [tempUsers, setTempUsers] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [permission, setPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:users';

  const currentTheme = useAppTheme();

  // Load persisted searchData
  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  // Persist on change
  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);


  const getUsers = async () => {
    try {
      const { data } = await ApiMServer.get('/user/all');
      setAllUsers(data);
      setTempUsers(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  useEffect(() => {
    setPermission(user?.permission?.users?.write || false);
    getUsers();
  }, []);

  const sortUsersByName = (list) => [...list].sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
  });

  const applySearch = async (termRaw) => {
    const term = String(termRaw || '').trim();
    if (!term) {
      setTempUsers(allUsers);
      return;
    }

    const localMatches = allUsers.filter((item) => matchesUserSearch(item, term));
    if (localMatches.length > 0) {
      setTempUsers(localMatches);
      return;
    }

    try {
      const { data } = await ApiMServer.get('/getusersfilter', { params: { filter: term } });
      setTempUsers(Array.isArray(data) ? sortUsersByName(data) : []);
    } catch (error) {
      console.error(error);
      setTempUsers([]);
    }
  };

  const handleSearch = () => {
    applySearch(searchData);
  };

  useEffect(() => {
    const term = searchData.trim();
    if (!term) {
      setTempUsers(allUsers);
      return undefined;
    }

    const timer = setTimeout(() => {
      applySearch(term);
    }, 350);

    return () => clearTimeout(timer);
  }, [allUsers, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  return (
    <Page className="p-3" title="Usuários">
      <Header page={'Usuários'} />

      {loading && <Reload />}

      <Row>
        <Col xs={8} sm={6} md={6} lg={6} xl={6} xxl={6}>
          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
            placeholder="Nome, e-mail, CPF/CNPJ, telefone ou empresa"
            inputGroupStyle={{ width: '100%', maxWidth: 420 }}
          />
        </Col>

        <Col xs={4} sm={6} md={6} lg={6} xl={6} xxl={6} className="text-md-end text-center">

          <Button
            className='ms-2 mt-2 mb-2'
            disabled={!permission}
            variant="success"
            onClick={() => { window.open(`${process.env.REACT_APP_API_MOTOMCO}/api/v1/users/relatorio?type=xlsx`, '_blank') }}
          >
            {'Relatório'}
          </Button>

          {/*           <Button
            style={{ width: 250 }}
            className={`mt-2 mb-2 me-2 ${currentTheme === 'dark' ? 'btn-dark' : 'btn-success'}`}
            onClick={() => { getUsersFilter() }}
            variant={currentTheme === 'dark' ? "dark" : "success"}
          >
            Buscar Filtro
          </Button>

          <Button
            style={{ width: 250 }}
            className={`mt-2 mb-2 ${currentTheme === 'dark' ? 'btn-dark' : 'btn-success'}`}
            onClick={() => { getUsers() }}
            variant={currentTheme ? "dark" : "success"}
          >
            Buscar Todos
          </Button>
           */}
        </Col>
      </Row>

      {tempUsers && (
        <Results
          user={user}
          data={tempUsers}
          currentTheme={currentTheme}
        />
      )}
    </Page>
  );
};

export default User;
